import React, { useEffect, useState } from 'react';

function CameraVersion(props) {
  console.log('image', props);
  const { detail } = props;
  if (detail.version == 'A') {
    return <img style={{ height: props.size }} alt="test" src="/icons_camera/Standard-150W.png" />;
  }
  if (detail.version == 'B') {
    return <img style={{ height: props.size }} alt="test" src="/icons_camera/Mini-150W.png" />;
  }
  if (detail.version == 'C') {
    return <img style={{ height: props.size }} alt="test" src="/icons_camera/smartcam_datacam.jpg" />;
  }
  if (detail.version == 'DC2') {
    return <img style={{ height: props.size }} alt="test" src="/icons_camera/camera_dc2.png" />;
  }
  if (detail.version == 'MC2') {
    return <img style={{ height: props.size }} alt="test" src="/icons_camera/camera_mc2.png" />;
  }
  return <img style={{ height: props.size }} alt="test" src="/icons_camera/Standard-150W.png" />;
}
export default CameraVersion;
